export var ProcessState;
(function (ProcessState) {
    ProcessState[ProcessState["ERROR"] = 0] = "ERROR";
    ProcessState[ProcessState["LOADING"] = 1] = "LOADING";
    ProcessState[ProcessState["SUCCESS"] = 2] = "SUCCESS";
    ProcessState[ProcessState["NONE"] = 3] = "NONE";
})(ProcessState || (ProcessState = {}));
export var NotificationSeverity;
(function (NotificationSeverity) {
    NotificationSeverity["INFO"] = "info";
    NotificationSeverity["WARNING"] = "warning";
    NotificationSeverity["ERROR"] = "error";
})(NotificationSeverity || (NotificationSeverity = {}));
export var FilterConnection;
(function (FilterConnection) {
    FilterConnection["and"] = "and";
    FilterConnection["or"] = "or";
})(FilterConnection || (FilterConnection = {}));
export var FilterOperator;
(function (FilterOperator) {
    FilterOperator["contains"] = "contains";
    FilterOperator["eq"] = "eq";
})(FilterOperator || (FilterOperator = {}));
